/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  link: {
    width: 110,
    minHeight: 30,
    color: '#148BA3',
    background: '#EEEAEA',
    cursor: 'pointer',
    textTransform: 'none',
  },
}));
